<template>
  <div class="h-remove-child-margin">
    <slot></slot>
    <div class="confirmation-popup__actions">
      <input type="text" class="a-form-control" v-model="userInput" />
      <button class="a-btn-primary" @click="handleSubmit" type="button" :disabled="!isValidUserInput()">{{ confirmButton.label }}</button>
      <button class="a-btn-primary" @click="cancelButton.click" type="button">{{ cancelButton.label }}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    confirmationMessage: {
      type: String,
      required: true
    },
    confirmButton: {
      type: Object,
      required: true
    },
    cancelButton: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      userInput: ''
    }
  },
  methods: {
    isValidUserInput() {
      return this.userInput.toLowerCase() === this.confirmationMessage.toLowerCase()
    },
    handleSubmit() {
      if (this.isValidUserInput()) {
        this.confirmButton.click()
      }
    }
  }
}
</script>

<style lang="scss">
.confirmation-popup {
  &__actions {
    * {
      margin: 0 10px 10px 0;
    }
  }
}
</style>
